import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { PersistedStoreState } from './persistedStore.types';

const initialState: PersistedStoreState = {
  isRestoredByPersistedStore: false,
};

export const persistedStoreSlice = createSlice({
  name: 'persistedStore',
  initialState,
  reducers: {
    setIsRestoredByPersistedStore: (state, action: PayloadAction<boolean>) => {
      state.isRestoredByPersistedStore = action.payload;
    },
  },
});

export const { setIsRestoredByPersistedStore } = persistedStoreSlice.actions;
